import { BoxProps } from 'UIKit/Box/types'
import { TokenAmount } from 'config/types'
import useMatchBreakpoints from 'hooks/useMatchBreakpoints'
import Column from 'layout/Components/Column'
import React, { useCallback } from 'react'
import styled from 'styled-components'
import EstimateProfit from 'views/InhouseGame/components/EstimateProfit'

import useAuthenticationModal from 'hooks/useAuthenticationModal'
import useKeydownEventListener from 'hooks/useKeydownEventListener'

import { Trans } from 'react-i18next'
import { useAuth } from 'state/auth/hooks'

import { InHouseGameButton, LimboAnimation } from 'views/InhouseGame/components/styled'
import { useLimboGameStatus } from '../../hooks'

const LimboBetAction: React.FC<
  {
    disabled: boolean
    onBet: () => void
    hotkeyEnable?: boolean
  } & BoxProps
> = ({ disabled, hotkeyEnable, onBet, ...props }) => {
  const { isPlaying } = useLimboGameStatus()
  const { hasSession } = useAuth()

  const [onPresentLoginModal] = useAuthenticationModal()

  const eventHandler = useCallback(
    (event) => {
      if (event && event?.key === ' ') {
        event.preventDefault()

        if (!hotkeyEnable || disabled || isPlaying) return null

        onBet()
      }
    },
    [hotkeyEnable, disabled, isPlaying, onBet],
  )
  useKeydownEventListener(eventHandler)

  return (
    <Column {...props}>
      {hasSession ? (
        <StyledButton disabled={disabled || isPlaying} onClick={onBet}>
          {isPlaying ? <LimboAnimation /> : <Trans>Bet</Trans>}
        </StyledButton>
      ) : (
        <StyledButton onClick={onPresentLoginModal}>
          <Trans>Login and Play</Trans>
        </StyledButton>
      )}
    </Column>
  )
}

const LimboManualBet: React.FC<
  BoxProps & {
    disabled?: boolean
    tokenAmount: TokenAmount
    targetMultiplier: number
    hotkeyEnable: boolean
    onBet: () => void
  }
> = ({ hotkeyEnable, disabled, tokenAmount, targetMultiplier, onBet, ...props }) => {
  const { isDesktop } = useMatchBreakpoints()

  return (
    <StyledWrapper {...props}>
      <Column>
        {!isDesktop && (
          <LimboBetAction
            hotkeyEnable={hotkeyEnable}
            mb="12px"
            disabled={disabled}
            onBet={() => {
              onBet()
            }}
          />
        )}
        <EstimateProfit
          profitInUsd={tokenAmount?.amount.multipliedBy(targetMultiplier).minus(tokenAmount.amount)}
          mb="14px"
        />
      </Column>

      {isDesktop && (
        <LimboBetAction
          hotkeyEnable={hotkeyEnable}
          disabled={disabled}
          onBet={() => {
            onBet()
          }}
        />
      )}
    </StyledWrapper>
  )
}

const StyledWrapper = styled(Column)``

const StyledButton = styled(InHouseGameButton)`
  min-height: 42px !important;
  max-height: 42px !important;
`

export default LimboManualBet
